import React from 'react';
import { FiShield, FiArrowRight } from 'react-icons/fi';
import { useNavigate } from 'react-router-dom';

const SEASON_LABELS = {
  spring: 'Spring',
  summer: 'Summer',
  fall: 'Fall',
  winter: 'Winter'
};

function ToolboxTalkReminder({ suggestedTopic, currentSeason, onDismiss, onNavigate }) {
  const navigate = useNavigate();

  const handleGoToSafety = () => {
    if (onNavigate) onNavigate();
    navigate('/safety');
  };

  const handleGoToTraining = () => {
    if (onNavigate) onNavigate();
    navigate('/training');
  };

  return (
    <div style={{
      position: 'fixed', top: 0, left: 0, right: 0, bottom: 0,
      zIndex: 1000, backgroundColor: 'rgba(0,0,0,0.5)',
      display: 'flex', alignItems: 'center', justifyContent: 'center'
    }}>
      <div style={{
        backgroundColor: '#ffffff', maxWidth: '500px', width: '95%',
        borderRadius: '16px', padding: '28px',
        boxShadow: '0 20px 60px rgba(0,0,0,0.3)'
      }}>
        <div style={{ textAlign: 'center', marginBottom: '20px' }}>
          <div style={{
            width: '64px', height: '64px', borderRadius: '50%',
            backgroundColor: '#dbeafe', display: 'flex', alignItems: 'center', justifyContent: 'center',
            margin: '0 auto 12px'
          }}>
            <FiShield size={32} color="#2563eb" />
          </div>
          <h2 style={{ margin: '0 0 4px', color: '#1e40af', fontSize: '20px' }}>
            Weekly Safety Talk Due
          </h2>
          <p style={{ color: '#6b7280', fontSize: '14px', margin: 0 }}>
            No toolbox talk or Field Safety training lesson has been completed this week.
          </p>
        </div>

        {suggestedTopic && (
          <div style={{
            backgroundColor: '#eff6ff', borderRadius: '12px',
            padding: '16px', marginBottom: '20px', border: '1px solid #bfdbfe'
          }}>
            <div style={{ fontSize: '12px', color: '#3b82f6', fontWeight: 600, marginBottom: '4px', display: 'flex', alignItems: 'center', gap: '6px' }}>
              Suggested Topic
              {currentSeason && suggestedTopic.season && suggestedTopic.season.includes(currentSeason) && (
                <span style={{
                  fontSize: '10px', padding: '1px 6px', borderRadius: '8px',
                  backgroundColor: '#fef3c7', color: '#92400e'
                }}>
                  Recommended for {SEASON_LABELS[currentSeason] || currentSeason}
                </span>
              )}
            </div>
            <div style={{ fontSize: '16px', fontWeight: 600, color: '#1f2937' }}>
              {suggestedTopic.title}
            </div>
            <div style={{ fontSize: '12px', color: '#6b7280', marginTop: '4px' }}>
              {suggestedTopic.category} &bull; {suggestedTopic.duration_minutes} min
            </div>
          </div>
        )}

        <button onClick={handleGoToTraining} style={{
          width: '100%', padding: '14px', fontSize: '15px', fontWeight: 600,
          border: 'none', borderRadius: '10px', cursor: 'pointer',
          backgroundColor: '#2563eb', color: '#fff', marginBottom: '8px',
          display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '8px'
        }}>
          Go to Field Safety Training <FiArrowRight />
        </button>
        <button onClick={handleGoToSafety} style={{
          width: '100%', padding: '12px', fontSize: '14px', fontWeight: 600,
          border: '1px solid #93c5fd', borderRadius: '10px', cursor: 'pointer',
          backgroundColor: '#eff6ff', color: '#1d4ed8', marginBottom: '8px',
          display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '8px'
        }}>
          Go to Safety Talks <FiArrowRight />
        </button>
        <button onClick={onDismiss} style={{
          width: '100%', padding: '12px', fontSize: '14px', fontWeight: 500,
          border: '1px solid #d1d5db', borderRadius: '10px', cursor: 'pointer',
          backgroundColor: 'transparent', color: '#6b7280'
        }}>
          Remind Me Later
        </button>
      </div>
    </div>
  );
}

export default ToolboxTalkReminder;
